export const DEFAULT_TIMEZONE = 'Europe/Moscow';

export const TIMEZONE_OPTIONS = [
    { id: 'Europe/Kaliningrad', code: 'Europe/Kaliningrad', name: 'Europe/Kaliningrad (UTC+2)' },
    { id: 'Europe/Moscow', code: 'Europe/Moscow', name: 'Europe/Moscow (UTC+3)' },
    { id: 'Europe/Samara', code: 'Europe/Samara', name: 'Europe/Samara (UTC+4)' },
    { id: 'Asia/Yekaterinburg', code: 'Asia/Yekaterinburg', name: 'Asia/Yekaterinburg (UTC+5)' },
    { id: 'Asia/Omsk', code: 'Asia/Omsk', name: 'Asia/Omsk (UTC+6)' },
    { id: 'Asia/Novosibirsk', code: 'Asia/Novosibirsk', name: 'Asia/Novosibirsk (UTC+7)' },
    { id: 'Asia/Krasnoyarsk', code: 'Asia/Krasnoyarsk', name: 'Asia/Krasnoyarsk (UTC+7)' },
    { id: 'Asia/Irkutsk', code: 'Asia/Irkutsk', name: 'Asia/Irkutsk (UTC+8)' },
    { id: 'Asia/Yakutsk', code: 'Asia/Yakutsk', name: 'Asia/Yakutsk (UTC+9)' },
    { id: 'Asia/Vladivostok', code: 'Asia/Vladivostok', name: 'Asia/Vladivostok (UTC+10)' },
    { id: 'Asia/Magadan', code: 'Asia/Magadan', name: 'Asia/Magadan (UTC+11)' },
    { id: 'Asia/Kamchatka', code: 'Asia/Kamchatka', name: 'Asia/Kamchatka (UTC+12)' },
    { id: 'Europe/Minsk', code: 'Europe/Minsk', name: 'Europe/Minsk (UTC+3)' },
    { id: 'Asia/Almaty', code: 'Asia/Almaty', name: 'Asia/Almaty (UTC+5)' },
    { id: 'Asia/Tashkent', code: 'Asia/Tashkent', name: 'Asia/Tashkent (UTC+5)' },
    { id: 'Europe/Kyiv', code: 'Europe/Kyiv', name: 'Europe/Kyiv (UTC+2)' },
    { id: 'Europe/Berlin', code: 'Europe/Berlin', name: 'Europe/Berlin (UTC+1/+2)' },
    { id: 'Europe/London', code: 'Europe/London', name: 'Europe/London (UTC+0/+1)' },
    { id: 'UTC', code: 'UTC', name: 'UTC' },
];

export const findTimezoneOption = (timezone) =>
    TIMEZONE_OPTIONS.find((it) => it.code === timezone) || {
        id: timezone || DEFAULT_TIMEZONE,
        code: timezone || DEFAULT_TIMEZONE,
        name: timezone || DEFAULT_TIMEZONE,
    };
